module.exports = __webpack_public_path__ + "static/20131108-PIVOTAL-231edit1.7070753e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/20131108-PIVOTAL-231edit1.jpg
// module id = 1048
// module chunks = 32308089046778